import { ReactNode } from 'react';

interface AuthCardProps {
  children: ReactNode;
}

/** The panel holding the form: white on the light ground, black on the dark one. */
export const AuthCard = ({ children }: AuthCardProps) => (
  <div className="mx-auto w-full max-w-[380px] rounded-2xl bg-auth-card p-6 shadow-[0_6px_28px_hsl(0_0%_0%/0.07)]">
    {children}
  </div>
);
